<template>
  <el-container class="main-frame">
    <el-header style="padding: 0;" :class="{'page-bg': currentRouteName !== 'home'}">
      <z-header></z-header>
    </el-header>
    <!--内容区-->
    <el-container>
      <el-aside :class="{'aside-small':toggleFlag}" style="overflow: inherit; background: #111d3b;">
        <z-menu></z-menu>
        <!--点击展开收起-->
        <div class="aside-up">
          <span class="aside-up-img" @click="toggle" :class="{'up-active':toggleFlag}"></span>
        </div>
      </el-aside>
      <el-main class="ctx-main-background" style="padding: 0; overflow: hidden;">
        <!--页签-->
        <!-- <div class="open-tab-container shrink"> -->
        <!--页签-->
        <!-- <page-tag-list></page-tag-list>
                </div> -->
        <!--主体区域-->
        <div class="content-container" :class="{'page-bg': currentRouteName === 'home'}">
          <!--缓存页面-->
          <!-- <keep-alive :include="cachedPageList" max="20"> -->
          <router-view v-if="isRouterAlive" :key="routerKey"></router-view>
          <!-- </keep-alive> -->
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import ZMenu from "./components/Menu/z-menu";
import PageTagList from "./components/PageTagList/page-tag-list";
import { mapActions, mapState, mapMutations } from "vuex";
import { MSG_MODES, MSG_TYPES, setMessage } from "../libs/message";
import ArrayUtils from "../libs/utils/ArrayUtils";
import ZHeader from "./components/Header/z-header";
import UserPersistence from "../persistence/UserPersistence";
import api from "../api/account-info";
import UserApi from "../api/UserApi";
import { routers } from "../router/router";
import tooTitle from "./account-management/component/too-title.vue";
import { moduleId, state } from "../store/modules/account-info";
import assetApi from "../api/assest-management/base-management/index";
import PersonalizeSettingApi from "../api/finance-account/finance-account-setting/PersonalizeSettingApi";

export default {
  components: {
    ZHeader,
    ZMenu,
    PageTagList,
    tooTitle
  },
  provide() {
    //通过provider来提供变量,此处为重新加载路由的方法
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      //菜单
      shrink: false,
      fullHeight: document.documentElement.clientHeight,
      fullWidth: document.documentElement.clientWidth,
      heightTimer: false,
      widthTimer: false,
      isRouterAlive: true, //用于刷新页面

      orgId: "",
      orgList: [],
      currentRouteName: 'home',
    };
  },
  computed: {
    ...mapState("zHeader", ["openHomePage", "accountVisible", "toggleFlag"]),
    ...mapState("user", {
      accountList: state => state.userBaseInfo.orgList,
      departmentList: state => state.departmentList,
      userName: state => state.userBaseInfo.user.name,
      projectType: state => state.projectType
    }),
    ...mapState("app", {
      pageTagsList: state => state.pageOpenedList
    }),
    ...mapState("user", {
      initStatus: state => state.initStatus
    }),
    cachedPageList() {
      return this.$store.state.app.cachedPageList;
    },
    ...mapState("account-info", {
      routerKey: state => state.routerKey
    })
  },
  watch: {
    fullHeight(val) {
      this.setHeightData(val);
      if (!this.heightTimer) {
        this.fullHeight = val;
        this.heightTimer = true;
        let that = this;
        let timer = setTimeout(function () {
          that.heightTimer = false;
          clearTimeout(timer);
        }, 400);
      }
    },
    fullWidth(val) {
      this.setWidthData(val);
      if (!this.widthTimer) {
        this.fullWidth = val;
        this.widthTimer = true;
        let that = this;
        let timer = setTimeout(function () {
          that.widthTimer = false;
          clearTimeout(timer);
        }, 400);
      }
    },
    $route: {
      handler: function(val, oldVal) {
        this.currentRouteName = val.name;
      },
      immediate: true,
    },
    initStatus: {
      handler: function (newVal, oldVal) {
        if (newVal == 2) {
          this.closeAllPage();
          this.setInitStatus(1);
        }
      }
    },
  },
  methods: {
    ...mapActions("app", ["initApp"]),
    ...mapMutations("zHeader", ["setGetUserId", "setToggleFlag"]),
    ...mapMutations("user", [
      "setInitStatus",
      "setAccountId",
      "setProjectType"
    ]),
    ...mapMutations("app", [
      "setHeightData",
      "setWidthData",
      "addCachedPage",
      "removeCachedPage",
      "removeLastTags"
    ]),
    ...mapActions("user", [
      "loadBaseInfo",
      "getHotKey",
      "getDepartmentQuery"
    ]),
    ...mapMutations("user", [
      "setFirstLogin",
      "updateMenuList",
      "setProjectType",
      'initAccountSelect'
    ]),
    ...mapActions("account-info", ["getEnumerationList"]),
    init() {
      this.initApp();
    },
    toggle() {
      this.setToggleFlag(!this.toggleFlag);
      // this.setEnterProDialogVisible(false);//新增凭证页关闭常用凭证
    },
    //用于刷新当前页
    reload() {
      //通过对router-view的v-if属性赋值，重新加载路由
      this.removeCachedPage(this.$route.name); //用于移除缓存
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        this.addCachedPage(this.$route.name); //增加缓存
      });
    },

    closeAllPage() {
      let pageOpenedList = this.pageTagsList;
      let path,
        removeNamesCount = pageOpenedList.length - 1;
      for (let i = pageOpenedList.length - 1; i >= 1; i--) {
        path = pageOpenedList[i].fullPath;
      }
      let location = { name: "home" };
      this.$router.replace(
        location,
        () => {
          this.removeLastTags(removeNamesCount);
        },
        () => {
          this.removeLastTags(removeNamesCount);
        }
      );
    },
    async initialize() {
      this.init();
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;

          window.fullWidth = document.documentElement.clientWidth;
          that.fullWidth = window.fullWidth;
        })();
      };
      this.setHeightData(this.fullHeight);
      this.setWidthData(this.fullWidth);
    }
  },
  mounted() {
    this.initialize();
  },
  destroyed() {

  }
};
</script>

<style lang="scss">
$open-tab-list-h: 40px;

.open-tab-container {
  transition: all 0.5s;
  height: 46px;
  background-color: #ffffff;
  z-index: 1;
  /*overflow: hidden;*/
}

.main-frame {
  width: 100%;
  height: 100%;

  .el-header {
    height: 56px !important;
    line-height: 56px;
    padding-bottom: 56px;
    // width: calc(100% - 230px);
    width: 100%;
    /*overflow: hidden !important;*/
    display: flex;
    flex-direction: row;
    justify-content: space-between;

  }

  .ctx-main-background {
    //background: #f3f3f3;
    position: relative;
  }

  .content-container {
    /*position: fixed;*/
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    // height: calc(100% - 46px);
    // height: -moz-calc(100% - 46px);
    // height: -webkit-calc(100% - 46px);
    padding: 10px 20px;
  }
  .page-bg{
    background: #f3f3f3;
  }

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
  }

  .el-aside {
    position: relative;
    width: 230px !important;
    transition: width 0.3s;

    .logo {
      width: 180px;
      height: 56px;
      background: #19233c;
      transition: width 0.3s;

      .logo-img2 {
        z-index: 22;
        position: absolute;
        top: 12px;
        width: 31px;
        height: 31px;
        border-radius: 50%;
        margin-left: 10px;
        transition: all 0.8s;
        background: #fff;
        border: 1px solid #fff;
      }

      .logo-img1 {
        width: 103px;
        height: 32px;
        margin: 12px 0 0 30px;
        transition: margin-left 0.1s;
      }
    }

    .logo-small {
      position: relative;
      width: 52px !important;

      .logo-div {
        z-index: 11;
        position: absolute;
        left: 5px;
        top: 7px;
        width: 43px;
        height: 43px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        animation: myfirst 3s linear 0s infinite;
      }

      .logo-img2 {
        &:hover {
          cursor: pointer;
        }
      }
    }

    @keyframes myfirst {
      0% {
        transform: scale(0.8);
      }

      50% {
        transform: scale(1);
      }

      100% {
        transform: scale(0.8);
      }
    }

    .aside-up {
      position: absolute;
      z-index: 333;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
      text-align: center;
      background: #111d3b;

      .aside-up-img {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-top: 10px;
        background: url("../assets/icon-up.png") no-repeat;
        background-size: 100% 100%;
        transition: all 0.3s;

        /*border-radius: 50%;*/
        &:hover {
          cursor: pointer;
          background: url("../assets/icon-up-active.png") no-repeat;
          background-size: 100% 100%;
        }
      }

      .up-active {
        transform: rotate(180deg);
        box-shadow: 0 0 5px #fff;

        &:hover {
          box-shadow: 0 0 5px #65a4fa;
        }
      }
    }
  }

  .aside-small {
    width: 52px !important;
  }

  .system {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 20px;
    padding-right: 0px;
    flex: 1;

    .item {
      width: 160px;
      height: 160px;
      background: linear-gradient(180deg, #f0f6ff 0%, #f8fbff 100%);
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 32px;
      margin-right: 32px;

      box-sizing: border-box;
      margin-bottom: 32px;
      flex-direction: column;

      img {
        width: 64px;
        height: 64px;
        margin-bottom: 8px;
      }

      span {
        font-size: 16px;
      }

      &:hover {
        box-shadow: inset 0px 2px 4px -1px rgba(79, 126, 237, 0.12),
          inset 0px 4px 5px 1px rgba(33, 93, 232, 0.08),
          inset 0px 1px 10px 1px rgba(33, 93, 232, 0.05);
      }
    }
  }

  .changeSyst {
    height: 50px;
    line-height: 45px;
    color: #70798e;
    font-weight: 400;

    &:hover {
      color: #215de8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue